import type {
  BillingFunnelAnalyticsProperties,
  CookieConsentAnalyticsProperties,
  DemoRequestClickAnalyticsProperties,
} from './index';

async function loadAnalyticsService() {
  const { analyticsService } = await import('./index');
  return analyticsService;
}

export async function captureTryForFreeClick(): Promise<void> {
  const analyticsService = await loadAnalyticsService();
  await analyticsService.captureTryForFreeClick();
}

export async function captureDemoRequestClick(
  properties: DemoRequestClickAnalyticsProperties,
): Promise<void> {
  const analyticsService = await loadAnalyticsService();
  await analyticsService.captureDemoRequestClick(properties);
}

export async function captureCookieConsentChoice(
  properties: CookieConsentAnalyticsProperties,
): Promise<void> {
  const analyticsService = await loadAnalyticsService();
  await analyticsService.captureCookieConsentChoice(properties);
}

export async function captureShareOpened(): Promise<void> {
  const analyticsService = await loadAnalyticsService();
  await analyticsService.captureShareOpened();
}

export async function captureBillingFunnelStep(
  properties: BillingFunnelAnalyticsProperties,
): Promise<void> {
  const analyticsService = await loadAnalyticsService();
  await analyticsService.captureBillingFunnelStep(properties);
}
